module.exports = __webpack_public_path__ + "img/face-sad-cry.c4e71892.svg";